module.exports = __webpack_public_path__ + "img/serve2.fa459844.png";